import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, MapPin, Clock, ArrowRight } from 'lucide-react';
import { careers } from '../mock';

export const Careers = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section id="careers" className="py-24 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center space-y-4 mb-16"
        >
          <span className="inline-block px-4 py-2 bg-[#2196F3]/10 text-[#2196F3] rounded-full text-sm font-semibold">
            Join Our Team
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#071B4D]">
            Shape the Future of Technology
          </h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-600">
            Join a team of innovators, problem-solvers, and technology enthusiasts
            building the next generation of enterprise solutions.
          </p>
        </motion.div>

        {/* Benefits */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-4 gap-6 mb-12"
        >
          {[
            'Competitive Salary',
            'Health Benefits',
            'Remote Work',
            'Learning Budget'
          ].map((benefit, index) => (
            <div
              key={index}
              className="p-6 bg-white rounded-xl shadow-md text-center border border-gray-200"
            >
              <div className="text-lg font-semibold text-[#071B4D]">{benefit}</div>
            </div>
          ))}
        </motion.div>

        {/* Job Listings */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="space-y-4"
        >
          {careers.map((job) => (
            <motion.div
              key={job.id}
              variants={itemVariants}
              whileHover={{ x: 10 }}
              className="group p-6 bg-white rounded-xl border border-gray-200 hover:border-[#2196F3] transition-all duration-300 shadow-md hover:shadow-xl"
            >
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-[#071B4D] group-hover:text-[#2196F3] transition-colors">
                    {job.title}
                  </h3>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                    <div className="flex items-center gap-2">
                      <Briefcase className="w-4 h-4 text-[#2196F3]" />
                      {job.department}
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin className="w-4 h-4 text-[#2196F3]" />
                      {job.location}
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4 text-[#2196F3]" />
                      {job.type}
                    </div>
                  </div>
                </div>
                <button className="flex items-center gap-2 px-6 py-3 bg-[#2196F3] text-white font-semibold rounded-lg hover:bg-[#1976D2] transition-colors duration-300 group-hover:gap-3">
                  Apply Now
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};